import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import api from '../api';

export const registerUser = createAsyncThunk('user/register', async (userData) => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    //const response = await api.post('/register/', userData);
    const response = await axios.post(`${API_BASE_URL}/api/register`, userData);
    return response.data;
});

export const loginUser = createAsyncThunk('user/login', async (userData) => {
    const response = await api.post('/login/', userData);
    return response.data;
});
const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: null,
        error: null,
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(registerUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(registerUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(registerUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default userSlice.reducer;
